module.exports = __webpack_public_path__ + "static/media/my-account-add-provider.24bc8fcb.svg";